module.exports = __webpack_public_path__ + "static/img/stay-option-icon-publicpc.8dc4422d.svg";